var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveCustomerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 65,
    viewBox: "0 0 173 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 27.3771C2.6541 29.9349 4.47932 32.4358 6.41861 34.8231C8.41494 37.324 13.4343 44.2016 17.3699 42.0986C18.2255 41.6439 18.8529 40.9049 19.4233 40.166C22.8456 35.7325 24.2145 30.1622 26.2108 24.9898C27.4086 21.8068 31.7435 12.4282 36.5347 16.0091C37.5043 16.6912 38.0747 17.7712 38.5881 18.8511C42.5807 26.5813 43.5504 35.6757 47.8853 43.2354C49.9386 46.8731 55.4713 47.4984 57.8669 43.8606C60.8899 39.4271 62.544 34.0273 64.8826 29.2528C66.0233 26.9792 67.1071 24.4782 68.5901 22.3752C70.3012 19.9311 73.4383 18.7374 76.1761 20.1016C78.8569 21.4089 80.511 24.4214 81.4806 27.1497C84.0474 34.3684 86.3289 41.6439 89.0667 48.8057C91.4053 54.9444 94.4853 63.4135 102.3 63.9819C106.691 64.3229 108.688 59.7757 109.829 56.3085C113.251 46.0774 123.061 10.6662 124.202 7.88103C125.685 4.30012 128.993 -0.701778 133.442 1.57181C137.435 3.61804 143.652 21.8636 145.249 26.8655C146.447 30.6738 147.531 34.5389 148.843 38.3472C149.869 41.3597 151.466 47.271 155.858 46.3047C156.885 46.0774 157.74 45.4521 158.539 44.7132C161.961 41.587 163.844 37.2104 165.954 33.1179C168.35 28.5139 170.517 23.7962 172 18.8511",
    stroke: "#16C7F9",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveCustomerIcon);
export default __webpack_public_path__ + "static/media/active_customer_icon.adf00a4f9a2844706ee00963e0596a7c.svg";
export { ForwardRef as ReactComponent };